export function getNumericValue(value: undefined | string | number): string | number
{
    if (!value)
    {
        return 0;
    }

    if ('number' !== typeof value)
    {
        let temp: string   = value.replace(',', '.');
        let number: number = parseFloat(temp);
        value              = number.toString() === temp ? number : value;
    }

    return value;
}

export function clamp(value: number, min: number, max: number): number
{
    return min < max
        ? (value < min ? min : value > max ? max : value)
        : (value < max ? max : value > min ? min : value);
}

export function toInt(value: null | undefined | string | number): number
{
    const possibleThousandsSeparators = [',', '.', '\'', '_'];

    if (!value)
    {
        return 0;
    }

    if ('number' === typeof value)
    {
        return value;
    }

    value = String(value);

    const matchedPossibleDecimalSeparator = value.match(/[.,]/g);
    if (matchedPossibleDecimalSeparator)
    {
        const decimalSeparator    = matchedPossibleDecimalSeparator[matchedPossibleDecimalSeparator.length - 1];
        const thousandsSeparators = [...possibleThousandsSeparators];

        if (value.split(decimalSeparator).length === 2)
        {
            const index = thousandsSeparators.indexOf(decimalSeparator);
            if (index > -1)
            {
                thousandsSeparators.splice(index, 1);
            }
        }

        for (const separator of thousandsSeparators)
        {
            value = value.split(separator).join('');
        }

        value = value.split(decimalSeparator).join('.');
    }
    else
    {
        for (const separator of possibleThousandsSeparators)
        {
            value = value.split(separator).join('');
        }
    }

    return parseFloat(value) || 0;
}